/** One rule for every year: the last sprint that has started, or the first of them. */
export interface DatedSprint {
  id: string;
  /** The day it starts, as a day key or a wire instant: only the first ten characters are read. */
  startDate?: string;
}

/** `today` is a day key, not an instant: an instant makes a sprint starting today tomorrow's. */
export const openingSprint = <T extends DatedSprint>(sprints: T[], today: string): T | undefined => {
  const dated = sprints.filter(sprint => !!sprint.startDate);
  if (!dated.length) return undefined;
  const started = dated.filter(sprint => (sprint.startDate as string).slice(0, 10) <= today);
  return started.length ? started[started.length - 1] : dated[0];
};
